import createComponent, {
  type ElementWithProps
} from '@carvana/merch-components/createComponent';
import cx from 'classnames';

export const Body = createComponent('div', {
  className: 'relative flex flex-col gap-2xl sm:gap-4xl sm:h-full sm:min-h-0'
});

export const Content = createComponent<
  ElementWithProps<{ isExactMatch: boolean }>
>('div', ({ isExactMatch }) => ({
  className: cx(
    'flex flex-col gap-2xl',
    isExactMatch
      ? 'sm:flex-row'
      : 'sm:grid sm:grid-cols-2 sm:h-full sm:min-h-0 md:grid-cols-[auto_1fr]'
  ),
  'data-is-exact-match': isExactMatch.toString()
}));

export const Title = createComponent('h2', {
  className: 't-heading-lg sm:t-heading-2xl'
});

export const Subtitle = createComponent('p', {
  className: 't-body-sm sm:t-body-md'
});

export const PanelColumn = createComponent<
  ElementWithProps<{ isExactMatch: boolean }>
>('aside', ({ isExactMatch }) => ({
  className: isExactMatch ? 'sm:min-w-0 sm:flex-1' : 'h-fit md:w-[292px]',
  'data-is-exact-match': isExactMatch.toString()
}));

export const VehiclesWrapper = createComponent<
  ElementWithProps<{ isExactMatch: boolean }>
>('div', ({ isExactMatch }) => ({
  className: isExactMatch
    ? 'sm:min-w-0 sm:flex-1'
    : 'sm:h-full sm:min-h-0 sm:overflow-y-auto',
  'data-is-exact-match': isExactMatch.toString()
}));

export const GlowEllipse = createComponent('span', {
  className:
    'pointer-events-none absolute left-1/2 -z-10 size-[337px] -translate-x-1/2 -translate-y-[110%] rounded-full bg-[#228be6]/40 blur-[64px]'
});
